import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import trackAction from 'utils/tracking';

import IconSvg from 'components/Core/IconSvg';

import GLOBAL_MEDIA_QUERIES from 'constants/Screen';

import {
  FacilityWrapper,
  FacilityTitle,
  FacilityItemsWrap,
  FacilityItem,
  FacilityName,
  FacilityToggle,
  FacilityToggleWrap,
} from './Facility.styles';

const Facility = ({ title, ctaShowMore, ctaShowLess, facilityItems }) => {
  const [toggleState, setToggleState] = useState('hide');

  const toggle = () => setToggleState(toggleState === 'show' ? 'hide' : 'show');

  const showAllItems = toggleState === 'show';
  const toggleCta = showAllItems ? ctaShowLess : ctaShowMore;

  const onClickShowMore = () => {
    trackAction('facilities', toggleCta, 'click');
    return toggle();
  };

  /**
   * TODO: Should this be our main screen definition?
   * Need to check along with tailwind settings.
   */
  const facilityMediaQueries = {
    md: '(min-width: 768px) and (max-width: 1023px)',
    lg: '(min-width: 1024px)',
  };

  /* eslint-disable max-len */
  const getFacilityItem = ({ id, icon, name }, size) => (
    <FacilityItem key={`facilityItem-${id}`}>
      <div className="flex flex-col justify-center h-full items-center text-center rounded-lg bg-secondary-300">
        <IconSvg icon={icon} size={size} className="text-secondary" />
        <FacilityName>{name}</FacilityName>
      </div>
    </FacilityItem>
  );
  /* eslint-enable */

  return (
    <FacilityWrapper>
      <div className="container mx-auto px-4">
        <FacilityTitle>{title}</FacilityTitle>
        <FacilityItemsWrap showAllItems={showAllItems}>
          <Media queries={facilityMediaQueries} defaultMatches={{ lg: true }}>
            {(matches) => {
              let iconSize = 25;
              if (matches.md) {
                iconSize = 30;
              } else if (matches.lg) {
                iconSize = 45;
              }

              return facilityItems.map((facility) => getFacilityItem(facility, iconSize));
            }}
          </Media>
        </FacilityItemsWrap>
        <Media queries={GLOBAL_MEDIA_QUERIES} defaultMatches={{ sm: true }}>
          {(matches) => (
            <>
              {(matches.xs || matches.sm || matches.md || matches.lg) && facilityItems.length > 6 && (
                <FacilityToggleWrap>
                  <FacilityToggle onClick={() => onClickShowMore()}>
                    {showAllItems && <IconSvg icon="arrow-up" size={10} className="my-auto text-primary" />}
                    {!showAllItems && <IconSvg icon="arrow-down" size={10} className="my-auto text-primary" />}
                    <span className="pl-2">{toggleCta}</span>
                  </FacilityToggle>
                </FacilityToggleWrap>
              )}
              {(matches.xl || matches.xxl) && facilityItems.length > 8 && (
                <FacilityToggleWrap>
                  <FacilityToggle onClick={() => onClickShowMore()}>
                    {showAllItems && <IconSvg icon="arrow-up" size={10} className="my-auto text-primary" />}
                    {!showAllItems && <IconSvg icon="arrow-down" size={10} className="my-auto text-primary" />}
                    <span className="pl-2">{toggleCta}</span>
                  </FacilityToggle>
                </FacilityToggleWrap>
              )}
            </>
          )}
        </Media>
      </div>
    </FacilityWrapper>
  );
};
Facility.defaultProps = {
  title: 'Faciliteiten',
  ctaShowMore: 'bekijk meer',
  ctaShowLess: 'bekijk less',
  facilityItems: [],
};

Facility.propTypes = {
  title: PropTypes.string,
  ctaShowMore: PropTypes.string,
  ctaShowLess: PropTypes.string,
  facilityItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      icon: PropTypes.string,
    }),
  ),
};
export default Facility;
